import { __awaiter } from "tslib";
import { sendUIInteractionAnalyticsEvent } from '@app/services/analytics/analytics-send-event';
import { dictionary } from '@app/services/currentDictionary.service';
import { getWordList } from '@app/services/glosbe-dictionary-api/glosbe-dictionary-wordlist';
import { getSimilarPhrases } from '@app/services/glosbe-dictionary-api/glosbe-similar-phrases';
import { isMobile } from '@app/services/isMobile';
import { generatePhraseUrlForCurrentDictionary } from '@app/services/url-builder.service';
import { debounce } from '@app/utils/debounce';
import { get } from 'svelte/store';
import { searchPhrase, setSimilarPhrases, setWordlist, similarPhrases, wordlist } from './Search.store';
const debouncedSendUiWordlistUpdateEvent = debounce(200, () => {
    sendUIInteractionAnalyticsEvent({
        action: `wordlist-update-${isMobile() ? 'mobile' : 'desktop'}`,
    });
});
function loadWordlist() {
    return __awaiter(this, void 0, void 0, function* () {
        const phrase = get(searchPhrase);
        if (!phrase || phrase.trim().length === 0) {
            setWordlist({ before: [], after: [], success: true });
            return;
        }
        const { l1, l2 } = get(dictionary);
        const tmp = yield getWordList({
            l1: l1.code,
            l2: l2.code,
            phrase: phrase,
            before: 0,
            after: 20,
        });
        setWordlist(tmp);
        debouncedSendUiWordlistUpdateEvent();
    });
}
let lastLoadSimilarPhrasesQueryTime = 0;
function loadSimilarPhrases() {
    return __awaiter(this, arguments, void 0, function* (similarPhrasesSectionCount = 3) {
        const phrase = get(searchPhrase);
        if (!phrase || phrase.trim().length === 0) {
            setWordlist({ before: [], after: [], success: true });
            return;
        }
        const { l1, l2 } = get(dictionary);
        let queryStartTimestamp = Date.now();
        lastLoadSimilarPhrasesQueryTime = queryStartTimestamp;
        const tmp = yield getSimilarPhrases({
            l1: l1.code,
            l2: l2.code,
            phrase: phrase,
            number: similarPhrasesSectionCount,
        });
        if (queryStartTimestamp === lastLoadSimilarPhrasesQueryTime) {
            // there were no intermediate requests keep going with the results
            setSimilarPhrases(tmp);
            debouncedSendUiWordlistUpdateEvent();
        }
    });
}
export function wordlistSelectActiveItem(event) {
    return __awaiter(this, void 0, void 0, function* () {
        const wordlistData = get(wordlist);
        let selectedItem;
        if (wordlistData && !wordlistData.isLazy && wordlistData.words && Number.isInteger(wordlistData.activeItem)) {
            let selectedIndex = (wordlistData.currentPosition || 0) - wordlistData.dummyElementsCount;
            if (selectedIndex < wordlistData.combinedWords.length) {
                selectedItem = wordlistData.combinedWords[selectedIndex];
            }
            if (selectedItem) {
                window.location.href = generatePhraseUrlForCurrentDictionary(selectedItem.phrase);
                event.preventDefault();
                event.stopPropagation();
            }
        }
    });
}
export function similarPhrasesSelectActiveItem(event) {
    return __awaiter(this, void 0, void 0, function* () {
        const similarPhrasesData = get(similarPhrases);
        let selectedItem = null;
        let reverse = false;
        if (similarPhrasesData && similarPhrasesData.straight && !similarPhrasesData.straight.isLazy
            && similarPhrasesData.straight.words && Number.isInteger(similarPhrasesData.straight.currentPosition)) {
            let selectedIndex = (similarPhrasesData.straight.currentPosition || 0);
            if (selectedIndex < similarPhrasesData.straight.combinedWords.length) {
                selectedItem = similarPhrasesData.straight.combinedWords[selectedIndex];
            }
        }
        if (selectedItem === null && similarPhrasesData && similarPhrasesData.reverse && !similarPhrasesData.reverse.isLazy
            && similarPhrasesData.reverse.words && Number.isInteger(similarPhrasesData.reverse.currentPosition)) {
            let selectedIndex = (similarPhrasesData.reverse.currentPosition || 0);
            if (selectedIndex < similarPhrasesData.reverse.combinedWords.length) {
                selectedItem = similarPhrasesData.reverse.combinedWords[selectedIndex];
                reverse = true;
            }
        }
        if (selectedItem != undefined) {
            window.location.href = generatePhraseUrlForCurrentDictionary(selectedItem.phrase, reverse);
            event.preventDefault();
            event.stopPropagation();
        }
    });
}
export function initWordlistLoader(skipInitialLoad = false) {
    let prevDictionaryVal = get(dictionary);
    let prevSearchPhraseVal = get(searchPhrase);
    const sidebarWordlistContainer = document.getElementById("sidebar-wordlist");
    const sidebar = sidebarWordlistContainer;
    /*
        if (sidebar) {
            dictionary.subscribe(val => {
                if (val.l1.code !== prevDictionaryVal.l1.code || val.l2.code !== prevDictionaryVal.l2.code) {
                    loadWordlist();
                }
                prevDictionaryVal = val;
            });
            searchPhrase.subscribe(val => {
                if (prevSearchPhraseVal !== val) {
                    loadWordlist();
                }
                prevSearchPhraseVal = val;
            });
        } else {*/
    dictionary.subscribe(val => {
        if (val.l1.code !== prevDictionaryVal.l1.code || val.l2.code !== prevDictionaryVal.l2.code) {
            loadSimilarPhrases();
        }
        prevDictionaryVal = val;
    });
    let isInitial = skipInitialLoad;
    searchPhrase.subscribe(val => {
        if (prevSearchPhraseVal !== val) {
            // PS: first (initial) set is not done by user interaction but set by us; we want to skip it and keep the oryginal wordlist
            if (isInitial) {
                isInitial = false;
            }
            else if (prevSearchPhraseVal !== val) {
                loadSimilarPhrases();
            }
        }
        prevSearchPhraseVal = val;
    });
    // TODO - this is a workaround for missing wordlist
    // PS: not needed anymore, but keeping it for now
    // JP: 2025.07.22 - this is a workaround for missing wordlist, need to recover for now
    if (!isMobile() && document.getElementById("force-wordlist-reload")) {
        loadSimilarPhrases(7);
    }
}
